import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../../redux/user/actions.user';
import asyncDispatch from '../../../../services/mini/asyncDispatch';

class GithubPromoInfo extends React.Component {

    constructor() {
        super();
        this.state = {
            inProcess: false
        };
    }

    componentDidMount() {
        this._isMounted = true; //todo: refactor it
        this.getInfo();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getInfo = async () => {
        const { getGithubPromoInfo } = this.props;

        this.setState({ inProcess: true });

        try {
            await getGithubPromoInfo();
            this.hideLoader();
        } catch (e) {
            this.hideLoader();
        }
    }

    hideLoader() {
        if (this._isMounted) {
            this.setState({ inProcess: false });
        }
    }

    render() {
        const {
            interactionTotal,
            interactionBalance,
            numOfAlanProjects,
            numOfStars
        } = this.props;

        const { inProcess } = this.state;

        return (
            <div className="github-promo-info">
                <li><a onClick={this.getInfo}>Check stars <i className={`icon icon-alan-refresh ${inProcess && 'in-process'}`}/></a>  </li>
                {numOfAlanProjects && <div className="github-promo-info_data">
                    <div className="github-promo-info_data_item">
                        <div className="github-promo-info_data_item_text">Interaction Balance</div>
                        <b>{interactionBalance}</b>
                    </div>
                    <div className="github-promo-info_data_item">
                        <div className="github-promo-info_data_item_text">Interaction Total</div>
                        <b >{interactionTotal}</b>
                    </div>
                    <div className="github-promo-info_data_item">
                        <div className="github-promo-info_data_item_text">Starred</div>
                        <b>{numOfStars} out of {numOfAlanProjects}</b>
                    </div>
                </div>}
            </div>
        );
    }
}


function mapStateToProps(state, ownProps) {
    return {
        interactionTotal: state.user.interactionTotal,
        interactionBalance: state.user.interactionBalance,
        numOfAlanProjects: state.user.numOfAlanProjects,
        numOfStars: state.user.numOfStars,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getGithubPromoInfo: (param) => asyncDispatch(actions.getGithubPromoInfo, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(GithubPromoInfo);

